import { render, staticRenderFns } from "./UpdateClasses.vue?vue&type=template&id=14cee382&scoped=true"
import script from "./UpdateClasses.vue?vue&type=script&lang=js"
export * from "./UpdateClasses.vue?vue&type=script&lang=js"
import style0 from "./UpdateClasses.vue?vue&type=style&index=0&id=14cee382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cee382",
  null
  
)

export default component.exports